export const LEADERBOARD_LIMIT = 25;

export const VIEW = {
    EARNED: 'EARNED',
    AVAILABLE: 'AVAILABLE',
    COMPARISON: 'COMPARISON'
};
